module.exports = "build/assets/floatingGirlMobile.70e77eab.png";